import { StrictMode } from "react";
import { createRoot } from "react-dom/client";
import App from "./src/App.jsx";
import { exportIfAsked, importOldProfile } from "./src/migrate.js";
import { initAds } from "./src/ads.js";

// iframe export-mode (profile migration between domains): send and stop —
// don't boot the whole game inside the hidden iframe
if (exportIfAsked()) {
  document.getElementById("root").textContent = "";
} else {
  importOldProfile();
  initAds();
  // PWA/TWA: offline-fallback-SW (kun i prod — cache-bøvl er ikke dev værd)
  if ("serviceWorker" in navigator && location.hostname !== "localhost") {
    window.addEventListener("load", () => {
      navigator.serviceWorker.register("/sw.js").catch(() => {});
    });
  }
  createRoot(document.getElementById("root")).render(
    <StrictMode>
      <App />
    </StrictMode>
  );
}
